import './DistributionEditModal.scss';

import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';

import CapitalGainsOption from './CapitalGainsOption';
import DividendsOption from './DividendsOption.js';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import {
  CAPITAL_GAINS_TYPE_ID,
  DIVIDEND_TYPE_ID,
  REINVEST_ID,
  DISTRIBUTE_TO_FUND_ID, CASH_ID
} from 'services/Preferences';
import { hasDistributionOptionChanged2 } from 'services/DividendsCapitalGains';
import { AAMBeaconButton, AAMBeaconModal } from 'components/shared/Beacon';
import { handleCancel } from './NonRetirementNotIncome2020Modal';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';

export const checkIfShouldDisable = (
  capitalGainsDistributionTypeId,
  originalCapitalGainsDistributionTypeId,
  dividendsDistributionTypeId,
  originalDividendsDistributionTypeId
) => {
  const capitalGainsOptionChanged = hasDistributionOptionChanged2(
    capitalGainsDistributionTypeId,
    originalCapitalGainsDistributionTypeId
  );

  const dividendsOptionChanged = hasDistributionOptionChanged2(
    dividendsDistributionTypeId,
    originalDividendsDistributionTypeId
  );

  return !capitalGainsOptionChanged && !dividendsOptionChanged;
};

export const handleSave = (
  onSave,
  accountInfo,
  brokerageAssetType,
  capitalGains,
  dividends,
  capitalGainsDistributionTypeId,
  dividendsDistributionTypeId
) => {
  const { sourceAccountDescriptor } = accountInfo;

  const dividendOption = {
    sourceAccountDescriptor: {
      productType: accountInfo.productType,
      cusipId: sourceAccountDescriptor.cusipId,
      accountId: sourceAccountDescriptor.accountId,
      trpCode: accountInfo.trpCode
    },
    distributionTypeId: dividendsDistributionTypeId,
    disposition: { action: 'update' },
    typeId: DIVIDEND_TYPE_ID,
    brokeragePositionAssetType: brokerageAssetType
  };

  if (dividendOption.distributionTypeId === DISTRIBUTE_TO_FUND_ID) {
    dividendOption.targetAccountDescriptor =
      dividends?.fundInfo?.accountDescriptor || {};
  }

  const capitalGainOption = {
    sourceAccountDescriptor: {
      accountChecksum: accountInfo.accountChecksum,
      accountTypeId: accountInfo.accountTypeId,
      accountNumber: accountInfo.accountNumber,
      balanceValue: null,
      retirementAccount: null,
      suppressFromView: !accountInfo.viewEnabled,
      ticker: null,
      productType: accountInfo.productType,
      cusipId: accountInfo.cusipId,
      accountId: accountInfo.accountId,
      trpCode: accountInfo.trpCode
    },
    distributionTypeId: capitalGainsDistributionTypeId,
    disposition: { action: 'update' },
    typeId: CAPITAL_GAINS_TYPE_ID,
    brokeragePositionAssetType: brokerageAssetType
  };
  if (capitalGainOption.distributionTypeId === DISTRIBUTE_TO_FUND_ID) {
    capitalGainOption.targetAccountDescriptor =
      capitalGains?.fundInfo?.accountDescriptor || {};
  }

  const payload = {
    distributionOptions: [dividendOption, capitalGainOption]
  };

  onSave(payload);
};

const BrokerageMutualFundModal = ({
  distributionToEdit,
  onBeaconClose,
  onSave,
  requestStatus,
  isCustomerWebView
}) => {
  const { accountInfo, capitalGains, dividends, brokerageAssetType } =
    distributionToEdit;
  const [capitalGainsDistributionTypeId, setCapitalGainsDistributionTypeId] =
    useState(null);
  const [
    originalCapitalGainsDistributionTypeId,
    setOriginalCapitalGainsDistributionTypeId
  ] = useState(null);

  const [dividendsDistributionTypeId, setDividendsDistributionTypeId] =
    useState(null);
  const [
    originalDividendsDistributionTypeId,
    setOriginalDividendsDistributionTypeId
  ] = useState(null);
  const [submittedChange, setSubmittedChange] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    setDividendsDistributionTypeId(dividends.distributionTypeId);
    setCapitalGainsDistributionTypeId(capitalGains.distributionTypeId);
    setOriginalDividendsDistributionTypeId(dividends.distributionTypeId);
    setOriginalCapitalGainsDistributionTypeId(capitalGains.distributionTypeId);
  }, [distributionToEdit]);

  useEffect(() => {
    if (requestStatus.updateDividendsCapitalGains === 'REQUESTED') {
      setShowSpinner(true);
    }
    if (submittedChange) {
      if (
        requestStatus.updateDividendsCapitalGains === 'RECEIVED' ||
        requestStatus.updateDividendsCapitalGains === 'ERROR'
      ) {
        setShowSpinner(false);
        setSubmittedChange(false);
        handleCancel('distribution-brokerage-mutual-fund-edit-modal-v2');
      }
    }
  }, [requestStatus]);

  const shouldDisable = checkIfShouldDisable(
    capitalGainsDistributionTypeId,
    originalCapitalGainsDistributionTypeId,
    dividendsDistributionTypeId,
    originalDividendsDistributionTypeId
  );

  return (
    <AAMBeaconModal
      scale={'jumbo'}
      open={true}
      id={'distribution-brokerage-mutual-fund-edit-modal-v2'}
      className={'distribution-brokerage-mutual-fund-edit-modal-v2'}
      title={'Edit Dividends & Capital Gains'}
      onBeaconEventClose={onBeaconClose}
    >
      <div className="dividends-capital-gains-container">
        <div className="dividends-capital-gains-header-v2">
          Edit Dividends & Capital Gains
        </div>
        <div className="dividends-capital-gains-sub-header-v2 blocked_data">
          {accountInfo.accountName} {accountInfo.ticker} -{' '}
          {accountInfo.accountWChecksum}
        </div>
        <div className="distribution-options">
          <DividendsOption
            isBrokerage={true}
            label="Reinvest Dividend Payments"
            value={REINVEST_ID}
            onChange={(distributionTypeId) => {
              setDividendsDistributionTypeId(distributionTypeId);
              setCapitalGainsDistributionTypeId(distributionTypeId);
            }}
            selected={dividendsDistributionTypeId === REINVEST_ID}>
            <div className={'capital-gains-header-v2'}>
              Capital Gains Distribution Options
            </div>
            <CapitalGainsOption
              isBrokerage={true}
              label="Reinvest Capital Gains"
              value={REINVEST_ID}
              onChange={(distributionTypeId) => {
                setCapitalGainsDistributionTypeId(distributionTypeId);
              }}
              selected={capitalGainsDistributionTypeId === REINVEST_ID}
            />
            <CapitalGainsOption
              label="Cash"
              value={CASH_ID}
              onChange={(distributionTypeId) => {
                setCapitalGainsDistributionTypeId(distributionTypeId);
              }}
              selected={capitalGainsDistributionTypeId === CASH_ID}
            />
          </DividendsOption>
          <DividendsOption
            label="Cash"
            value={CASH_ID}
            onChange={(distributionTypeId) => {
              setDividendsDistributionTypeId(distributionTypeId);
              setCapitalGainsDistributionTypeId(distributionTypeId);
            }}
            selected={dividendsDistributionTypeId === CASH_ID}>
            <div className={'capital-gains-header-v2'}>
              Capital Gains Distribution Options
            </div>
            <CapitalGainsOption
              isBrokerage={true}
              label="Reinvest Capital Gains"
              value={REINVEST_ID}
              onChange={(distributionTypeId) => {
                setCapitalGainsDistributionTypeId(distributionTypeId);
              }}
              selected={capitalGainsDistributionTypeId === REINVEST_ID}
            />
            <CapitalGainsOption
              label="Cash"
              value={CASH_ID}
              onChange={(distributionTypeId) => {
                setCapitalGainsDistributionTypeId(distributionTypeId);
              }}
              selected={capitalGainsDistributionTypeId === CASH_ID}
            />
            {
              capitalGainsDistributionTypeId === REINVEST_ID &&
              <div>
                Not all holdings in your brokerage account allow Reinvest Dividend
                Payments as an option. If the holding does not offer this option,
                the election will remain as Cash after being in a pending status
                for 5 calendar days.
              </div>
            }
          </DividendsOption>
          <br />
        </div>
        <div className="div-caps-update-options-v2">
          <div />
          <div className="action-buttons-v2">
            <AAMBeaconButton
              variant="tertiary"
              className="cancel-beacon-button"
              onBeaconEventClick={() => {
                handleCancel(
                  'distribution-brokerage-mutual-fund-edit-modal-v2'
                );
              }}>
              Cancel
            </AAMBeaconButton>
            {showSpinner && (
              <div className="loading-spinner cost-basis-v2-loading-spinner">
                <Spinner />
              </div>
            )}
            {!showSpinner && (
              <AAMBeaconButton
                variant="positive"
                className="save-beacon-button"
                disabled={shouldDisable || isCustomerWebView}
                onBeaconEventClick={() => {
                  handleSave(
                    onSave,
                    accountInfo,
                    brokerageAssetType,
                    capitalGains,
                    dividends,
                    capitalGainsDistributionTypeId,
                    dividendsDistributionTypeId
                  );
                  setSubmittedChange(true);
                }}>
                Update
              </AAMBeaconButton>
            )}
          </div>
        </div>
      </div>
    </AAMBeaconModal>
  );
};

const mapStateToProps = (state) => ({
  requestStatus: state.requestStatus,
  isCustomerWebView: getCustomerWebView(state)
});

export default connect(mapStateToProps)(BrokerageMutualFundModal);
